import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import exportAllExports from "./Export/exportAllExports";
import { useGetLoginsPerMonthQuery } from "../../services/API/statisticsAPI";
import ChartCard from "./ChartCard";
import CsvDownloadButton from "./CsvDownloadButton";
import { baseOptions, monthlyScales, nullifyFutureMonths, yearLineDataset } from "./chartTheme";

const LoginsPerMonthNettoStats = () => {
  const { t } = useTranslation(["translation", "statistics"]);
  const todayYear = new Date().getFullYear();

  const { data: loginsPerMonth } = useGetLoginsPerMonthQuery(undefined, {
    pollingInterval: 60000,
  });

  // Initialize arrays with 12 months (0-11) for each year
  let datasetData = [
    new Array(12).fill(0), // Current year data
    new Array(12).fill(0), // Previous year data
  ];

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  loginsPerMonth?.map((item) => {
    const yearIndex = todayYear - item._id.year;
    const monthIndex = item._id.month - 1;

    // Only process if yearIndex is within bounds (0 or 1) and monthIndex is valid
    if (yearIndex >= 0 && yearIndex < datasetData.length && monthIndex >= 0 && monthIndex < 12) {
      datasetData[yearIndex][monthIndex] = item.count;
    }
    return null;
  });

  const loginsNettoData = {
    labels,
    datasets: [
      yearLineDataset({
        label: `${todayYear - 1} - netto`,
        data: datasetData[1],
        isCurrentYear: false,
      }),
      yearLineDataset({
        label: `${todayYear} - netto`,
        data: nullifyFutureMonths(datasetData[0]),
        isCurrentYear: true,
      }),
    ],
  };

  const options = {
    ...baseOptions(),
    interaction: { mode: "index", intersect: false },
    scales: monthlyScales(),
  };

  return (
    <ChartCard
      title={t("user.loginspermonth_netto", { ns: "statistics" })}
      action={
        <CsvDownloadButton
          data={exportAllExports.exportNetto(loginsPerMonth ?? [])}
          headers={exportAllExports.headersNetto()}
          filename={"stats_logins_per_month_netto.csv"}
        />
      }
    >
      <Line options={options} data={loginsNettoData} />
    </ChartCard>
  );
};

export default LoginsPerMonthNettoStats;
